import Header from '@/components/Header/Header';
import { showToast } from '@/components/Toast/Toast';
import { ToastTypes } from '@/components/Toast/Toast.types';
import { useBundles } from '@/services/bundles/bundles.service';
import { useActiveGlobalFreezes } from '@/services/freeze/freeze.service';
import { BundleDetails } from '@/types/bundles.types';
import useFranchiseeAlias from '@/utils/useFranchiseeAlias/useFranchiseeAlias';
import classNames from 'classnames';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './BundleLibrary.module.css';
import { UseQueryResult } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import BundleLibraryTable, {
  IBundleLibraryTableProps,
} from '@/pages/Franchisee/Bundles/BundleLibrary/BundleLibraryTable';

export interface IBundleLibraryProps {
  bundleHook?: (enabled: boolean) => UseQueryResult<AxiosResponse<BundleDetails[], any>, unknown>;
  libraryTableComponent?: FC<IBundleLibraryTableProps>;
}

const getNewData = (data: BundleDetails[] = []): BundleDetails[] =>
  data.map((bundle) => ({
    ...bundle,
    bundleStatus: bundle.fzGroupCount ? bundle.fzGroupCount > 0 : false,
  }));

const BundleLibrary: FC<IBundleLibraryProps> = ({ bundleHook, libraryTableComponent }) => {
  const { t } = useTranslation();
  const { data, isLoading, isError } = (bundleHook ?? useBundles)(true);
  const { alias } = useFranchiseeAlias();
  const { data: activeGlobalFreezeData } = useActiveGlobalFreezes(true);
  const freezeExists = activeGlobalFreezeData?.data && activeGlobalFreezeData?.data?.length > 0;

  if (isError) {
    showToast({
      label: t('error.fetchingBundles'),
      toastType: ToastTypes.Error,
      id: 'errorFetchingBundles',
    });
  }

  const BundleLibraryTableComponent = libraryTableComponent ?? BundleLibraryTable;

  return (
    <>
      <Header
        title={t('bundleLibrary.title')}
        breadcrumb={{ label: t('bundleLibrary.breadcrumb'), to: '/bundles/active' }}
      />
      <div
        className={classNames(styles.pageContainer, {
          [styles.withAlias]: alias !== null,
          [styles.withFreeze]: freezeExists,
        })}
      >
        <BundleLibraryTableComponent isLoading={isLoading} bundleRecords={getNewData(data?.data || [])} />
      </div>
    </>
  );
};

export default BundleLibrary;
